export const TEST_ID = 'mobileDrawerMenu';
